import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f07b7f7a&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=f07b7f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b7f7a",
  null
  
)

export default component.exports